const chatStateByKey = new Map();
export function readPersistedSmartFormChat(key) {
    if (!key)
        return null;
    return chatStateByKey.get(key) ?? null;
}
export function writePersistedSmartFormChat(key, state) {
    if (!key)
        return;
    chatStateByKey.set(key, state);
}
export function clearPersistedSmartFormChat(persistenceKey) {
    if (persistenceKey) {
        chatStateByKey.delete(persistenceKey);
        return;
    }
    chatStateByKey.clear();
}
